import React, { type FC, useMemo } from "react";
import { AppRoutes } from "@domain/routing/routeConstants";
import { FormattedMessage } from "react-intl";
import { GQL } from "@binale-tech/shared";
import { useLocation } from "react-router-dom";
import { ModuleNav, type NavItem } from "./ModuleNav";

export const ModuleDebLinks: FC<{ onOpenSettings: (pk: GQL.IProductKey) => void }> = ({ onOpenSettings }) => {
    const { pathname = "" } = useLocation();
    const selectedKeys = useMemo(() => [pathname], [pathname]);
    const items = useMemo<NavItem[]>(
        () => [
            {
                key: AppRoutes.debitor,
                to: AppRoutes.debitor,
                label: <FormattedMessage id="app.titles.Deb" />,
            },
            {
                key: "Tools",
                label: <FormattedMessage id="app.titles.ER.auswertung" />,
                children: [
                    {
                        key: AppRoutes.debitorAnalysisOpos,
                        to: AppRoutes.debitorAnalysisOpos,
                        label: "OPOS",
                    },
                    {
                        key: AppRoutes.debitorAnalysisAvis,
                        to: AppRoutes.debitorAnalysisAvis,
                        label: <FormattedMessage id="app.titles.ER.za" />,
                    },
                ],
            },
            {
                key: AppRoutes.debitorTemplates,
                to: AppRoutes.debitorTemplates,
                label: <FormattedMessage id="app.titles.templates" />,
            },
            {
                key: "settings",
                onClick: () => onOpenSettings(GQL.IProductKey.Deb),
                label: <FormattedMessage id="app.titles.settings" />,
            },
        ],
        [onOpenSettings],
    );
    return <ModuleNav selectedKeys={selectedKeys} items={items} />;
};
